// @flow
export { default } from './QuoteHead';



// WEBPACK FOOTER //
// ./src/components/quote/QuoteHead/index.js